import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import '../common/PanelHeader.js';
import Status from '../common/Status.js';
import '../common/CustomCheckboxProperty.js';
import '../common/ToolbarButton.js';

const StatusCellRenderer = React__default.memo(({ value, statuses, state }) => {
    return jsx(Status, { value: value, statuses: statuses, state: state });
});
StatusCellRenderer.displayName = 'StatusCellRenderer';

export { StatusCellRenderer as default };
//# sourceMappingURL=StatusCellRenderer.js.map
